import { getPageNumber, getQueries, mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';
import qs from 'query-string';

enum Selectors {
  // Target
  Pagination = '.gtm-pagination-container a:not(.Mui-disabled)',
  // Containers
  PaginationContainer = '.gtm-pagination-container',
}

export const mapTarget = mapTargetBySelectors([Selectors.Pagination]);

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;
  const isPagination = !!target?.closest(Selectors.PaginationContainer);

  const { page = 1 } = qs.parse(window.location.search);

  if (isPagination) {
    const pageNumber = getPageNumber({ target, page: Number(page) });

    return {
      event: 'clickPagination',
      eventCategory: 'Filtered List',
      pageNumber,
      ...(variantName && { variant_name: variantName }),
    };
  }

  return undefined;
};

export const onDatalayerCustomSearch = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }
  const { variantName = '', ...props } = target;

  return {
    event: 'searchFilter',
    eventCategory: 'Filtered List',
    ...props,
    ...(!!variantName && { variant_name: variantName }),
  };
};

export const onDatalayerCustomSort = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const {
    params: { sortOption, variantName = '' },
  } = target || {};

  return {
    event: 'sortContent',
    eventCategory: 'Filtered List',
    sortOption,
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerCustomFilters = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const {
    params: { filters, variantName = '' },
  } = target || {};

  const searchFilters = getQueries(filters);

  return {
    event: 'filterSelection',
    eventCategory: 'Filtered List',
    filters: searchFilters,
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerDownloadFile = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }
  const { fileName, linkText, fileExtension, position } = target;

  return {
    event: 'trackEvent-fileDownload',
    event_name: 'file_download',
    eventCategory: 'engagement',
    eventAction: 'file_download',
    eventLabel: fileName,
    position,
    ...(linkText && { link_text: linkText }),
    file_name: fileName,
    file_extension: fileExtension,
    type: 'cta',
  };
};
